export * from "../overrides/tab-bar";

// Soon to be depricated.
import { TabBar } from '../overrides/tab-bar';

export default TabBar;
